var $f5e5effd96d66274$exports = {};
const $f5e5effd96d66274$var$slider = document.querySelector(".slider");
let $f5e5effd96d66274$var$currentSlide = 1;
const $f5e5effd96d66274$var$totalSlides = 3;
const $f5e5effd96d66274$var$leftArrow = document.querySelector(".slider__arrow--left");
const $f5e5effd96d66274$var$rightArrow = document.querySelector(".slider__arrow--right");
function $f5e5effd96d66274$var$changeBackgroundImage(direction) {
    $f5e5effd96d66274$var$slider.classList.remove(`slider--slide-${$f5e5effd96d66274$var$currentSlide}`);
    if (direction === "next") $f5e5effd96d66274$var$currentSlide = $f5e5effd96d66274$var$currentSlide === $f5e5effd96d66274$var$totalSlides ? 1 : $f5e5effd96d66274$var$currentSlide + 1;
    else if (direction === "prev") $f5e5effd96d66274$var$currentSlide = $f5e5effd96d66274$var$currentSlide === 1 ? $f5e5effd96d66274$var$totalSlides : $f5e5effd96d66274$var$currentSlide - 1;
    $f5e5effd96d66274$var$slider.classList.add(`slider--slide-${$f5e5effd96d66274$var$currentSlide}`);
}
$f5e5effd96d66274$var$leftArrow.addEventListener("click", function() {
    $f5e5effd96d66274$var$changeBackgroundImage("prev");
});
$f5e5effd96d66274$var$rightArrow.addEventListener("click", function() {
    $f5e5effd96d66274$var$changeBackgroundImage("next");
});
setInterval(()=>{
    $f5e5effd96d66274$var$changeBackgroundImage("next");
}, 5000);


//# sourceMappingURL=index.bce454a2.js.map
